export const cronTestEn = {
  CRONS: 'Crons',
  CRON_TEST_INFO:
    'Manually run the scheduled crons for the current factor. These calls execute the real process and persist their results.',
  CRON_TEST_RUN: 'Run',
  CRON_TEST_RESULT: 'Result',
  CRON_TEST_RUN_SUCCESS: 'executed successfully',
  CRON_TEST_DATE_TIME_FORMAT_ERROR: 'Use YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss',
  CRON_TEST_DATE_FORMAT_ERROR: 'Use YYYY-MM-DD',
  CRON_TEST_LIST_PLACEHOLDER: 'Comma or line separated IDs',
  CRON_TEST_FIELD_NOW: 'Run date (now)',
  CRON_TEST_FIELD_COMPANY_ID: 'Company ID',
  CRON_TEST_FIELD_REPORT_SCHEDULE_IDS: 'Report schedule IDs',
  CRON_TEST_FIELD_THROUGH: 'Through date',
  CRON_TEST_FIELD_OVER_ADVANCE_IDS: 'Over Advance IDs',
  CRON_TEST_FIELD_INVOICE_IDS: 'Invoice IDs',
  CRON_TEST_FIELD_DATE_START: 'Start date',
  CRON_TEST_FIELD_DATE_END: 'End date',
  CRON_TEST_FIELD_COMPANY_CLIENT_ID: 'Client company ID',
  CRON_TEST_DESC_COLLECTION_FEE_FACTOR: 'Accrues collection fees for the current factor.',
  CRON_TEST_DESC_DEBTOR_STATEMENT:
    'Sends debtor statements for the factor, or only for one debtor if a company ID is set.',
  CRON_TEST_DESC_INTEREST: 'Runs the interest cron for the current factor.',
  CRON_TEST_DESC_OPEN_BALANCE_INTEREST:
    'Accrues open balance interest on over advances, optionally through a date and for specific over advances.',
  CRON_TEST_DESC_AUTOCHARGE_INTEREST:
    'Runs the autocharge interest cron for clients and brokers of the current factor.',
  CRON_TEST_DESC_NEGATIVE_CASH_RESERVE: 'Processes negative cash reserves for the current factor.',
  CRON_TEST_DESC_REPORT_SCHEDULER: 'Forces the scheduled reports of the factor, optionally only the given schedules.',
  CRON_TEST_DESC_COLLECTION_FEE_SCOPED:
    'Runs collection fees for the factor, a company or specific invoices. Without invoices it runs in background.',
  CRON_TEST_DESC_MONTHLY_STATEMENT: 'Generates the monthly statement for a client or broker.',
  CRON_TEST_DESC_DW_FINANCIAL_TOTALS: 'Populates the DW financial totals for the previous day and backdated payments.',
  CRON_TEST_DESC_DW_CUMULATIVE_LEDGER_RESYNC:
    'Repairs the DW cumulative ledger for a date range, optionally for a single client.',
  CRON_TEST_DESC_VOLUME_REBATE:
    'Creates the volume rebate requests of the month before the run date, or only for one client or broker if a company ID is set.',
}

export const cronTestEs: typeof cronTestEn = {
  CRONS: 'Crons',
  CRON_TEST_INFO:
    'Ejecuta manualmente los crons programados para el factor actual. Estas llamadas corren el proceso real y persisten sus resultados.',
  CRON_TEST_RUN: 'Ejecutar',
  CRON_TEST_RESULT: 'Resultado',
  CRON_TEST_RUN_SUCCESS: 'ejecutado correctamente',
  CRON_TEST_DATE_TIME_FORMAT_ERROR: 'Usa YYYY-MM-DD o YYYY-MM-DDTHH:mm:ss',
  CRON_TEST_DATE_FORMAT_ERROR: 'Usa YYYY-MM-DD',
  CRON_TEST_LIST_PLACEHOLDER: 'IDs separados por coma o salto de línea',
  CRON_TEST_FIELD_NOW: 'Fecha de ejecución (now)',
  CRON_TEST_FIELD_COMPANY_ID: 'ID de compañía',
  CRON_TEST_FIELD_REPORT_SCHEDULE_IDS: 'IDs de reportes programados',
  CRON_TEST_FIELD_THROUGH: 'Fecha hasta',
  CRON_TEST_FIELD_OVER_ADVANCE_IDS: 'IDs de Over Advance',
  CRON_TEST_FIELD_INVOICE_IDS: 'IDs de facturas',
  CRON_TEST_FIELD_DATE_START: 'Fecha de inicio',
  CRON_TEST_FIELD_DATE_END: 'Fecha de término',
  CRON_TEST_FIELD_COMPANY_CLIENT_ID: 'ID de compañía del cliente',
  CRON_TEST_DESC_COLLECTION_FEE_FACTOR: 'Devenga los collection fees del factor actual.',
  CRON_TEST_DESC_DEBTOR_STATEMENT:
    'Envía los estados de cuenta de deudores del factor, o solo de un deudor si se indica un ID de compañía.',
  CRON_TEST_DESC_INTEREST: 'Ejecuta el cron de intereses del factor actual.',
  CRON_TEST_DESC_OPEN_BALANCE_INTEREST:
    'Devenga intereses de saldo abierto en over advances, opcionalmente hasta una fecha y para over advances específicos.',
  CRON_TEST_DESC_AUTOCHARGE_INTEREST:
    'Ejecuta el cron de intereses autocargados para clientes y brokers del factor actual.',
  CRON_TEST_DESC_NEGATIVE_CASH_RESERVE: 'Procesa las reservas de caja negativas del factor actual.',
  CRON_TEST_DESC_REPORT_SCHEDULER: 'Fuerza los reportes programados del factor, opcionalmente solo los indicados.',
  CRON_TEST_DESC_COLLECTION_FEE_SCOPED:
    'Ejecuta collection fees para el factor, una compañía o facturas específicas. Sin facturas corre en segundo plano.',
  CRON_TEST_DESC_MONTHLY_STATEMENT: 'Genera el estado de cuenta mensual de un cliente o broker.',
  CRON_TEST_DESC_DW_FINANCIAL_TOTALS:
    'Pobla los totales financieros del DW del día anterior y de pagos con fecha retroactiva.',
  CRON_TEST_DESC_DW_CUMULATIVE_LEDGER_RESYNC:
    'Repara el ledger acumulado del DW para un rango de fechas, opcionalmente para un solo cliente.',
  CRON_TEST_DESC_VOLUME_REBATE:
    'Crea las solicitudes de volume rebate del mes anterior a la fecha de ejecución, o solo para un cliente o broker si se indica un company ID.',
}
